import React from "react";
import Icon from "@ant-design/icons";

const ChatIconSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.69644 7.5C6.69644 7.71312 6.7811 7.91751 6.9318 8.06821C7.08249 8.21891 7.28688 8.30357 7.5 8.30357C7.71312 8.30357 7.91751 8.21891 8.0682 8.06821C8.2189 7.91751 8.30356 7.71312 8.30356 7.5C8.30356 7.28688 8.2189 7.08249 8.0682 6.93179C7.91751 6.78109 7.71312 6.69643 7.5 6.69643C7.28688 6.69643 7.08249 6.78109 6.9318 6.93179C6.7811 7.08249 6.69644 7.28688 6.69644 7.5ZM10.0446 7.5C10.0446 7.71312 10.1293 7.91751 10.28 8.06821C10.4307 8.21891 10.6351 8.30357 10.8482 8.30357C11.0613 8.30357 11.2657 8.21891 11.4164 8.06821C11.5671 7.91751 11.6517 7.71312 11.6517 7.5C11.6517 7.28688 11.5671 7.08249 11.4164 6.93179C11.2657 6.78109 11.0613 6.69643 10.8482 6.69643C10.6351 6.69643 10.4307 6.78109 10.28 6.93179C10.1293 7.08249 10.0446 7.28688 10.0446 7.5ZM3.34827 7.5C3.34827 7.71312 3.43293 7.91751 3.58363 8.06821C3.73432 8.21891 3.93871 8.30357 4.15183 8.30357C4.36495 8.30357 4.56934 8.21891 4.72003 8.06821C4.87073 7.91751 4.95539 7.71312 4.95539 7.5C4.95539 7.28688 4.87073 7.08249 4.72003 6.93179C4.56934 6.78109 4.36495 6.69643 4.15183 6.69643C3.93871 6.69643 3.73432 6.78109 3.58363 6.93179C3.43293 7.08249 3.34827 7.28688 3.34827 7.5ZM14.4173 4.59375C14.039 3.69475 13.4966 2.88784 12.8052 2.19475C12.1186 1.50569 11.3036 0.95796 10.4062 0.582589C9.48547 0.195871 8.5078 0 7.5 0H7.46652C6.45202 0.00502232 5.46933 0.205915 4.54524 0.601004C3.65556 0.980225 2.84816 1.52892 2.16804 2.21652C1.48334 2.90792 0.945954 3.7115 0.574307 4.60714C0.189267 5.5346 -0.00492728 6.52065 9.49754e-05 7.53516C0.00577557 8.69777 0.280825 9.84326 0.803656 10.8817V13.4263C0.803656 13.6306 0.88479 13.8265 1.02921 13.9709C1.17363 14.1153 1.3695 14.1964 1.57374 14.1964H4.12002C5.15845 14.7193 6.30392 14.9943 7.46652 15H7.50168C8.50445 15 9.4771 14.8058 10.3928 14.4258C11.2857 14.0549 12.0977 13.5135 12.7834 12.832C13.4748 12.1473 14.0189 11.3471 14.3989 10.4548C14.794 9.53069 14.9949 8.54799 14.9999 7.53348C15.0049 6.51395 14.8074 5.52455 14.4173 4.59375ZM11.8878 11.9263C10.7142 13.0882 9.15735 13.7277 7.5 13.7277H7.47154C6.46207 13.7227 5.45929 13.4715 4.5737 12.9994L4.43307 12.9241H2.07596V10.567L2.00063 10.4263C1.52854 9.54074 1.27742 8.53795 1.2724 7.52846C1.2657 5.85938 1.90353 4.29241 3.07372 3.11216C4.24223 1.93192 5.80415 1.27902 7.47322 1.27232H7.50168C8.33872 1.27232 9.15065 1.43471 9.91571 1.75614C10.6623 2.0692 11.332 2.51953 11.9079 3.09542C12.4821 3.66964 12.9341 4.34096 13.2471 5.08761C13.5719 5.86105 13.7343 6.68136 13.731 7.52846C13.7209 9.19587 13.0663 10.7578 11.8878 11.9263Z"
      fill="#2A9D8F"
    />
  </svg>
);

const ReorderIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.30772 2.66602C6.20345 2.66598 6.09975 2.67937 6.00002 2.70576C5.9003 2.67937 5.7966 2.66598 5.69233 2.66602C5.07025 2.66602 4.56414 3.13762 4.56414 3.7173V3.73268H3.84619C3.82053 3.73268 3.7958 3.74101 3.77688 3.75604C3.75796 3.77108 3.74624 3.79171 3.74401 3.81386L3.33376 7.90273C3.33253 7.915 3.33425 7.92737 3.33883 7.93903C3.34341 7.9507 3.35073 7.96142 3.36034 7.9705C3.36995 7.97958 3.38163 7.98683 3.39464 7.99179C3.40766 7.99676 3.42172 7.99932 3.43594 7.99932H8.56411C8.57833 7.99932 8.59239 7.99676 8.60541 7.99179C8.61842 7.98683 8.6301 7.97958 8.63971 7.9705C8.64932 7.96142 8.65664 7.9507 8.66122 7.93903C8.66579 7.92737 8.66752 7.915 8.66629 7.90273L8.25604 3.81386C8.25381 3.79171 8.24209 3.77108 8.22317 3.75604C8.20425 3.74101 8.17952 3.73268 8.15386 3.73268H7.43591V3.7173C7.43591 3.13762 6.9298 2.66602 6.30772 2.66602ZM7.23079 3.7173V3.73268H6.82053V3.7173C6.82053 3.35388 6.6216 3.03297 6.31988 2.84408C6.82325 2.85029 7.23079 3.23951 7.23079 3.7173ZM5.38464 3.73268V3.7173C5.38464 3.33772 5.6419 3.01408 6.00002 2.89388C6.35815 3.01408 6.61541 3.33772 6.61541 3.7173V3.73268H5.38464ZM4.76926 3.7173C4.76926 3.23952 5.1768 2.85029 5.68017 2.84408C5.37845 3.03297 5.17952 3.35388 5.17952 3.7173V3.73268H4.76926V3.7173ZM3.94022 3.91045H4.3497L3.95729 7.82154H3.54781L3.94022 3.91045ZM8.05983 3.91045L8.45224 7.82154H4.16319L4.5556 3.91045H5.17952V4.17712C5.17952 4.20069 5.19032 4.2233 5.20956 4.23997C5.22879 4.25664 5.25488 4.26601 5.28208 4.26601C5.30928 4.26601 5.33537 4.25664 5.3546 4.23997C5.37384 4.2233 5.38464 4.20069 5.38464 4.17712V3.91045H7.23079V4.17712C7.23079 4.20069 7.24159 4.2233 7.26083 4.23997C7.28006 4.25664 7.30615 4.26601 7.33335 4.26601C7.36055 4.26601 7.38664 4.25664 7.40587 4.23997C7.42511 4.2233 7.43591 4.20069 7.43591 4.17712V3.91045H8.05983Z"
          stroke="white"
          strokeWidth="0.4"
        />
        <path
          d="M1.08574 5.88854C1.10003 5.26425 1.2286 4.65854 1.47003 4.08855C1.71717 3.50284 2.07145 2.97855 2.52288 2.5257C2.9743 2.07284 3.50002 1.71856 4.08573 1.47142C4.69144 1.21571 5.33429 1.08571 5.99857 1.08571C6.66285 1.08571 7.30571 1.21571 7.90999 1.47142C8.49402 1.71805 9.02438 2.07616 9.47141 2.5257C9.61284 2.66713 9.74569 2.81713 9.86855 2.97427L9.00855 3.64569C8.99154 3.65886 8.97858 3.67655 8.97118 3.69675C8.96377 3.71695 8.96222 3.73883 8.9667 3.75987C8.97118 3.78091 8.9815 3.80026 8.99649 3.8157C9.01147 3.83113 9.03051 3.84202 9.05141 3.84712L11.5614 4.4614C11.6328 4.47854 11.7028 4.42426 11.7028 4.3514L11.7143 1.76713C11.7143 1.67142 11.6043 1.61713 11.53 1.67713L10.7243 2.30713C9.62569 0.901423 7.91713 0 5.99714 0C2.72431 0 0.0614639 2.62284 3.57226e-05 5.88282C-0.000345568 5.89807 0.00232874 5.91324 0.00790115 5.92743C0.0134736 5.94163 0.0218313 5.95457 0.0324818 5.96549C0.0431324 5.9764 0.0558604 5.98508 0.0699157 5.991C0.0839709 5.99692 0.0990692 5.99997 0.114321 5.99996H0.971459C1.03432 5.99996 1.08432 5.94996 1.08574 5.88854ZM11.8857 5.99996H11.0285C10.9657 5.99996 10.9157 6.04996 10.9143 6.11139C10.9 6.73567 10.7714 7.34138 10.53 7.91138C10.2828 8.49709 9.92855 9.0228 9.47712 9.47423C9.02148 9.93175 8.47977 10.2945 7.88323 10.5417C7.2867 10.7888 6.64713 10.9155 6.00143 10.9142C5.35594 10.9154 4.7166 10.7888 4.1203 10.5417C3.524 10.2945 2.98254 9.93172 2.52716 9.47423C2.38574 9.3328 2.25288 9.1828 2.13002 9.02566L2.99002 8.35424C3.00703 8.34107 3.01999 8.32337 3.02739 8.30318C3.0348 8.28298 3.03635 8.2611 3.03187 8.24006C3.0274 8.21902 3.01707 8.19967 3.00209 8.18423C2.9871 8.1688 2.96806 8.1579 2.94716 8.15281L0.437176 7.53853C0.365748 7.52138 0.295748 7.57567 0.295748 7.64853L0.285748 10.2342C0.285748 10.3299 0.395748 10.3842 0.470033 10.3242L1.27574 9.69423C2.37431 11.0985 4.08287 11.9999 6.00286 11.9999C9.27712 11.9999 11.9385 9.37566 12 6.11711C12.0003 6.10186 11.9977 6.08669 11.9921 6.07249C11.9865 6.0583 11.9782 6.04536 11.9675 6.03444C11.9569 6.02352 11.9441 6.01485 11.9301 6.00893C11.916 6.00301 11.9009 5.99996 11.8857 5.99996Z"
          fill="white"
        />
      </svg>
    )}
    {...props}
  />
);

const ActiveOrdersIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 9 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.4 2.5H6.7V2.3C6.7 1.03 5.67 0 4.4 0C3.13 0 2.1 1.03 2.1 2.3V2.5H0.4C0.17875 2.5 0 2.67875 0 2.9V9.6C0 9.82125 0.17875 10 0.4 10H8.4C8.62125 10 8.8 9.82125 8.8 9.6V2.9C8.8 2.67875 8.62125 2.5 8.4 2.5ZM3 2.3C3 1.52625 3.62625 0.9 4.4 0.9C5.17375 0.9 5.8 1.52625 5.8 2.3V2.5H3V2.3Z"
          fill="#505050"
        />
        <path
          d="M6.11635 5.78786L5.18056 5.56531L6.33561 4.44694C6.35967 4.42316 6.3536 4.37886 6.32514 4.37209L4.69612 3.98467C4.68422 3.98185 4.67087 3.98702 4.66179 3.99877L3.00058 6.09431C2.98077 6.1191 2.98852 6.15823 3.01486 6.1645L3.75567 6.34068L2.92793 8.13409C2.91008 8.17325 2.94312 8.21172 2.97478 8.18808L6.12255 5.86559C6.15077 5.84503 6.14693 5.79514 6.11635 5.78786Z"
          fill="white"
        />
      </svg>
    )}
    {...props}
  />
);

const DownloadBillIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 8 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.75505 2.5067L5.35239 0.104911C5.2854 0.0379464 5.19497 0 5.10007 0H0.357273C0.159656 0 0 0.159598 0 0.357143V9.64286C0 9.8404 0.159656 10 0.357273 10H7.50273C7.70034 10 7.86 9.8404 7.86 9.64286V2.76004C7.86 2.66518 7.82204 2.57366 7.75505 2.5067ZM7.03604 2.92411H4.93483V0.823661L7.03604 2.92411Z"
          fill="#505050"
        />
        <path
          d="M2.23096 8.64543C2.26582 8.6899 2.33316 8.6899 2.36682 8.64543L3.5788 7.11298C3.62329 7.05649 3.58361 6.97236 3.51027 6.97236H2.75639V5.09615C2.75639 5.04327 2.7131 5 2.6602 5H1.93878C1.88588 5 1.84259 5.04327 1.84259 5.09615V6.97115H1.08751C1.01537 6.97115 0.974489 7.05529 1.01898 7.11178L2.23096 8.64543Z"
          fill="white"
        />
      </svg>
    )}
    {...props}
  />
);

const LoyaltyIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 11 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.04345 6.28635H1.95645C1.84818 6.28635 1.74702 6.23017 1.68606 6.13624C0.751007 4.69634 0.679275 1.92651 0.673849 1.51534C0.673509 1.49923 0.67334 1.48293 0.67334 1.46673C0.67334 1.27717 0.819516 1.1234 1.00003 1.12305C1.18021 1.12305 1.32732 1.2761 1.328 1.46539C1.328 1.46771 1.32808 1.48801 1.32884 1.52398C1.35767 2.50186 2.12425 3.28797 3.06235 3.28797C4.01869 3.28797 4.79671 2.47097 4.79671 1.46673C4.79671 1.2769 4.94331 1.12305 5.124 1.12305H5.87582C6.05659 1.12305 6.20311 1.2769 6.20311 1.46673C6.20311 2.47097 6.98121 3.28797 7.93755 3.28797C8.8765 3.28797 9.64359 2.50044 9.67114 1.52131C9.67174 1.48694 9.67191 1.46771 9.67191 1.46548C9.67259 1.2761 9.81893 1.12305 9.99919 1.12305C10.1797 1.1234 10.3265 1.27717 10.3265 1.46673C10.3265 1.48302 10.3263 1.49923 10.3261 1.51543C10.3205 1.92651 10.2488 4.69643 9.31384 6.13633C9.25288 6.23017 9.15164 6.28635 9.04345 6.28635Z"
          fill="#505050"
        />
        <path
          d="M5.49996 0C4.94293 0 4.48975 0.50356 4.48975 1.1225C4.48975 1.74145 4.94293 2.24492 5.49996 2.24492C6.05698 2.24492 6.51017 1.74145 6.51017 1.1225C6.51017 0.50356 6.05698 0 5.49996 0Z"
          fill="#505050"
        />
        <path
          d="M1.01025 0.898438C0.453204 0.898438 0 1.40198 0 2.0209C0 2.63981 0.453204 3.14335 1.01025 3.14335C1.5673 3.14335 2.02042 2.63981 2.02042 2.0209C2.02042 1.40198 1.5673 0.898438 1.01025 0.898438Z"
          fill="#505050"
        />
        <path
          d="M9.98966 0.898438C9.43262 0.898438 8.97949 1.402 8.97949 2.02094C8.97949 2.63979 9.43262 3.14335 9.98966 3.14335C10.5467 3.14335 10.9999 2.63979 10.9999 2.02094C10.9999 1.402 10.5467 0.898438 9.98966 0.898438Z"
          fill="#505050"
        />
        <path
          d="M9.09632 8.06055H1.90346C1.71999 8.06055 1.57129 7.83571 1.57129 7.5583V6.06055H9.4285V7.5583C9.4285 7.83571 9.27979 8.06055 9.09632 8.06055Z"
          fill="#505050"
        />
        <path
          d="M9.09632 6.36055H1.90346C1.71999 6.36055 1.57129 6.32682 1.57129 6.28521V6.06055H9.4285V6.28521C9.4285 6.32682 9.27979 6.36055 9.09632 6.36055Z"
          fill="white"
        />
      </svg>
    )}
    {...props}
  />
);

const LoyaltyProgramIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 25 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.7427 2.55078H22.744C23.1447 2.55159 23.4692 2.90106 23.4694 3.33188C23.4694 3.36592 23.4691 3.40012 23.4685 3.43403C23.4684 3.43696 23.4684 3.4399 23.4683 3.44283C23.468 3.46402 23.4677 3.48797 23.4672 3.51458C23.448 4.66231 23.2497 10.7466 21.2213 13.9445C21.086 14.1578 20.8614 14.2855 20.6211 14.2855H20.5733C20.5666 14.2857 20.56 14.2858 20.5533 14.2858H4.44666C4.20058 14.2858 3.97069 14.1581 3.83213 13.9446C1.70703 10.6721 1.54401 4.3771 1.53167 3.44263C1.5309 3.406 1.53052 3.36897 1.53052 3.33215C1.53052 2.90133 1.86273 2.55187 2.27299 2.55106H2.27453C2.68402 2.55106 3.01682 2.89891 3.01836 3.32911C3.01836 3.33437 3.01855 3.38051 3.02029 3.46226C3.0858 5.68471 4.82801 7.47129 6.96005 7.47129C9.13352 7.47129 10.9017 5.61449 10.9017 3.33215C10.9017 2.90073 11.2349 2.55106 11.6456 2.55106H12.7551V2.55078H13.5895C13.9906 2.55078 14.3161 2.90045 14.3161 3.33188C14.3161 5.59395 16.0126 7.43801 18.1095 7.47066C20.2117 7.43226 21.918 5.65724 21.9799 3.45619C21.9813 3.37808 21.9816 3.33437 21.9816 3.32931C21.9832 2.89979 22.3144 2.55248 22.723 2.55106"
          />
        </mask>
        <path
          d="M22.7301 3.05101L22.7499 3.05073L22.7355 2.05083L22.7158 2.05112L22.7301 3.05101ZM22.744 2.55078L22.746 1.55078H22.744V2.55078ZM23.4694 3.33188H24.4694V3.33144L23.4694 3.33188ZM23.4685 3.43403L22.4686 3.41507L22.4686 3.41907L23.4685 3.43403ZM23.4683 3.44283L22.4684 3.42723L22.4684 3.42942L23.4683 3.44283ZM23.4672 3.51458L22.4674 3.49731L22.4674 3.49783L23.4672 3.51458ZM21.2213 13.9445L22.0657 14.4803L22.0658 14.4801L21.2213 13.9445ZM20.5733 14.2855V13.2855H20.5592L20.5452 13.2859L20.5733 14.2855ZM3.83213 13.9446L4.67096 13.4002L4.67081 13.4L3.83213 13.9446ZM1.53167 3.44263L2.53162 3.42943L2.53145 3.42159L1.53167 3.44263ZM2.27299 2.55106V1.55106L2.27102 1.55106L2.27299 2.55106ZM3.01836 3.32911H4.01837L4.01835 3.32553L3.01836 3.32911ZM3.02029 3.46226L2.02048 3.48347L2.02072 3.49173L3.02029 3.46226ZM12.7551 2.55106V3.55106H13.7551V2.55106H12.7551ZM12.7551 2.55078V1.55078H11.7551V2.55078H12.7551ZM18.1095 7.47066L18.094 8.47053L18.1109 8.4708L18.1278 8.47049L18.1095 7.47066ZM21.9799 3.45619L22.9796 3.48432L22.9798 3.47345L21.9799 3.45619ZM21.9816 3.32931L20.9816 3.32573V3.32931H21.9816ZM22.744 1.55078H22.7427V3.55078H22.744V1.55078ZM24.4694 3.33144C24.469 2.41868 23.765 1.55284 22.746 1.55078L22.742 3.55078C22.6422 3.55058 22.5655 3.50511 22.5242 3.46056C22.4839 3.41724 22.4694 3.36948 22.4694 3.33232L24.4694 3.33144ZM24.4683 3.45298C24.469 3.41275 24.4694 3.37222 24.4694 3.33188H22.4694C22.4694 3.35961 22.4692 3.3875 22.4686 3.41507L24.4683 3.45298ZM22.4686 3.41907C22.4685 3.4221 22.4685 3.42469 22.4685 3.42723L24.4682 3.45844C24.4683 3.45511 24.4683 3.45182 24.4683 3.44898L22.4686 3.41907ZM22.4684 3.42942C22.4682 3.44932 22.4678 3.47198 22.4674 3.49731L24.4671 3.53185C24.4676 3.50396 24.4679 3.47873 24.4682 3.45624L22.4684 3.42942ZM22.0658 14.4801C23.1981 12.695 23.7774 10.1981 24.0869 8.10715C24.4013 5.98324 24.4571 4.12762 24.4671 3.53133L22.4674 3.49783C22.4581 4.04927 22.4052 5.80968 22.1085 7.81433C21.8069 9.85198 21.2729 11.9962 20.3769 13.4089L22.0658 14.4801ZM20.6211 15.2855C21.2249 15.2855 21.7585 14.9644 22.0657 14.4803L20.3769 13.4087C20.4135 13.3512 20.498 13.2855 20.6211 13.2855V15.2855ZM20.5733 15.2855H20.6211V13.2855H20.5733V15.2855ZM20.5452 13.2859C20.5479 13.2858 20.5506 13.2858 20.5533 13.2858V15.2858C20.5694 15.2858 20.5854 15.2855 20.6013 15.2851L20.5452 13.2859ZM20.5533 13.2858H4.44666V15.2858H20.5533V13.2858ZM4.44666 13.2858C4.55329 13.2858 4.63285 13.3415 4.67096 13.4002L2.99331 14.489C3.30852 14.9747 3.84787 15.2858 4.44666 15.2858V13.2858ZM4.67081 13.4C3.73223 11.9546 3.18314 9.74526 2.87903 7.67175C2.58001 5.6329 2.53745 3.87401 2.53159 3.42943L0.531761 3.45583C0.538226 3.94572 0.583351 5.80158 0.9002 7.96197C1.21197 10.0877 1.80694 12.6621 2.99346 14.4892L4.67081 13.4ZM2.53145 3.42159C2.53083 3.39207 2.53052 3.36205 2.53052 3.33215H0.530518C0.530518 3.37589 0.530975 3.41994 0.531895 3.46367L2.53145 3.42159ZM2.53052 3.33215C2.53052 3.40645 2.4615 3.55069 2.27497 3.55106L2.27102 1.55106C1.26396 1.55305 0.530518 2.39622 0.530518 3.33215H2.53052ZM2.27299 3.55106H2.27453V1.55106H2.27299V3.55106ZM2.27453 3.55106C2.08822 3.55106 2.01863 3.40735 2.01837 3.33269L4.01835 3.32553C4.015 2.39046 3.27983 1.55106 2.27453 1.55106V3.55106ZM2.01836 3.32911C2.01836 3.34297 2.01866 3.39636 2.02051 3.48347L4.02006 3.44105C4.01844 3.36465 4.01836 3.32577 4.01836 3.32911H2.01836ZM2.02072 3.49173C2.10081 6.20841 4.242 8.47129 6.96005 8.47129V6.47129C5.41402 6.47129 4.0708 5.16101 4.01985 3.43279L2.02072 3.49173ZM6.96005 8.47129C9.7313 8.47129 11.9017 6.12015 11.9017 3.33215H9.90174C9.90174 5.10883 8.53574 6.47129 6.96005 6.47129V8.47129ZM11.9017 3.33215C11.9017 3.40656 11.8325 3.55106 11.6456 3.55106V1.55106C10.6373 1.55106 9.90174 2.39489 9.90174 3.33215H11.9017ZM11.6456 3.55106H12.7551V1.55106H11.6456V3.55106ZM11.7551 2.55078V2.55106H13.7551V2.55078H11.7551ZM13.5895 1.55078H12.7551V3.55078H13.5895V1.55078ZM15.3161 3.33188C15.3161 2.41743 14.6097 1.55078 13.5895 1.55078V3.55078C13.4894 3.55078 13.4125 3.50529 13.371 3.46068C13.3307 3.41727 13.3161 3.36929 13.3161 3.33188H15.3161ZM18.1251 6.47078C16.6389 6.44764 15.3161 5.11466 15.3161 3.33188H13.3161C13.3161 6.07324 15.3863 8.42838 18.094 8.47053L18.1251 6.47078ZM18.1278 8.47049C20.8072 8.42155 22.9038 6.17528 22.9795 3.48432L20.9803 3.42806C20.9321 5.1392 19.6162 6.44297 18.0913 6.47082L18.1278 8.47049ZM22.9798 3.47345C22.9811 3.39575 22.9816 3.34407 22.9816 3.32931H20.9816C20.9816 3.325 20.9817 3.32383 20.9816 3.3308C20.9816 3.33571 20.9815 3.34309 20.9814 3.35294C20.9811 3.37258 20.9807 3.40142 20.9801 3.43893L22.9798 3.47345ZM22.9816 3.33289C22.9814 3.40696 22.9123 3.55041 22.7264 3.55106L22.7195 1.55107C21.7166 1.55456 20.985 2.39262 20.9816 3.32573L22.9816 3.33289Z"
          fill="#225E77"
          mask="url(#path-1-inside-1)"
        />
        <path
          d="M12.5 0C11.2341 0 10.2041 1.14445 10.2041 2.55112C10.2041 3.9578 11.2341 5.10204 12.5 5.10204C13.766 5.10204 14.7959 3.9578 14.7959 2.55112C14.7959 1.14445 13.766 0 12.5 0Z"
          fill="#225E77"
        />
        <path
          d="M12.7551 0V5.10204C13.8805 5.10184 14.7959 3.95764 14.7959 2.55102C14.7959 1.1444 13.8803 0.00020454 12.7551 0Z"
          fill="#225E77"
        />
        <path
          d="M2.29601 2.04102C1.03 2.04102 0 3.18542 0 4.59204C0 5.99866 1.03 7.14306 2.29601 7.14306C3.56202 7.14306 4.59184 5.99866 4.59184 4.59204C4.59184 3.18542 3.56202 2.04102 2.29601 2.04102Z"
          fill="#225E77"
        />
        <path
          d="M22.704 2.04102C21.438 2.04102 20.4082 3.18546 20.4082 4.59214C20.4082 5.99861 21.438 7.14306 22.704 7.14306C23.97 7.14306 25 5.99861 25 4.59214C25 3.18546 23.97 2.04102 22.704 2.04102Z"
          fill="#225E77"
        />
        <path
          d="M20.6735 16.8366H4.32622C3.90925 16.8366 3.57129 16.4925 3.57129 16.0679V13.7754H21.4284V16.0679C21.4284 16.4925 21.0905 16.8366 20.6735 16.8366Z"
          fill="#225E77"
        />
        <path
          d="M12.7551 16.8366H20.6952C21.1003 16.8366 21.4286 16.4925 21.4286 16.0679V13.7754H12.7551V16.8366Z"
          fill="#225E77"
        />
      </svg>
    )}
    {...props}
  />
);

const ChatIcon = (props: any) => <Icon component={ChatIconSvg} {...props} />;

const MicIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 10 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 6.09375C0 6.025 0.0545454 5.96875 0.121212 5.96875H1.0303C1.09697 5.96875 1.15152 6.025 1.15152 6.09375C1.15152 8.28594 2.87424 10.0625 5 10.0625C7.12576 10.0625 8.84848 8.28594 8.84848 6.09375C8.84848 6.025 8.90303 5.96875 8.9697 5.96875H9.87879C9.94545 5.96875 10 6.025 10 6.09375C10 8.72969 8.08182 10.9047 5.60606 11.2125V12.8125H7.80758C8.01515 12.8125 8.18182 13.0359 8.18182 13.3125V13.875C8.18182 13.9438 8.13939 14 8.08788 14H1.91212C1.86061 14 1.81818 13.9438 1.81818 13.875V13.3125C1.81818 13.0359 1.98485 12.8125 2.19242 12.8125H4.45455V11.2203C1.95 10.9391 0 8.75156 0 6.09375ZM5 8.75C3.57727 8.75 2.42424 7.575 2.42424 6.125V2.625C2.42424 1.175 3.57727 0 5 0C6.42273 0 7.57576 1.175 7.57576 2.625V6.125C7.57576 7.575 6.42273 8.75 5 8.75ZM6.42424 2.625C6.42424 1.83438 5.78939 1.1875 5 1.1875C4.21061 1.1875 3.57576 1.83438 3.57576 2.625V6.125C3.57576 6.91563 4.21061 7.5625 5 7.5625C5.78939 7.5625 6.42424 6.91563 6.42424 6.125V2.625Z"
          fill="white"
        />
      </svg>
    )}
    {...props}
  />
);

const CrownIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 49 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40.2847 28H8.71563C8.23332 28 7.78273 27.7497 7.51117 27.3313C3.34597 20.9173 3.02644 8.57904 3.00227 6.74748C3.00076 6.67569 3 6.60311 3 6.53093C3 5.68654 3.65114 5.00159 4.45525 5H4.45827C5.26087 5 5.91315 5.68178 5.91617 6.52498C5.91617 6.53529 5.91655 6.62572 5.91995 6.78595C6.04836 11.142 9.46309 14.6437 13.6419 14.6437C17.9019 14.6437 21.3676 11.0043 21.3676 6.53093C21.3676 5.68535 22.0206 5 22.8255 5H26.1745C26.9797 5 27.6324 5.68535 27.6324 6.53093C27.6324 11.0043 31.0985 14.6437 35.3585 14.6437C39.5411 14.6437 42.9581 11.1356 43.0808 6.77405C43.0835 6.62096 43.0842 6.53529 43.0842 6.52537C43.0872 5.68178 43.7391 5 44.5421 5H44.5448C45.3489 5.00159 46 5.68654 46 6.53093C46 6.60351 45.9992 6.67569 45.9981 6.74787C45.9736 8.57904 45.654 20.9177 41.4892 27.3317C41.2176 27.7497 40.7667 28 40.2847 28Z"
          fill="#225E77"
          fill-opacity="0.6"
        />
        <path
          d="M44.5782 5C44.5775 5 44.5767 5 44.5756 5C43.7917 5 43.1546 5.68179 43.1516 6.525C43.1516 6.53532 43.1513 6.62099 43.1483 6.77408C43.0284 11.1353 39.6909 14.6438 35.6055 14.6438C31.4445 14.6438 28.0594 11.0044 28.0594 6.53095C28.0594 5.68536 27.4215 5 26.6354 5H25V28H40.4172C40.8883 28 41.3285 27.7497 41.5937 27.3317C45.6621 20.9176 45.9742 8.5787 45.9978 6.74751C45.9993 6.67572 46 6.60314 46 6.53095C45.9996 5.68655 45.3636 5.00159 44.5782 5Z"
          fill="#225E77"
          fill-opacity="0.6"
        />
        <path
          d="M24.5 0C22.0187 0 20 2.24311 20 5.0002C20 7.75729 22.0187 10 24.5 10C26.9813 10 29 7.75729 29 5.0002C29 2.24311 26.9813 0 24.5 0Z"
          fill="#225E77"
        />
        <path
          d="M25 0V10C27.2058 9.9996 29 7.75698 29 5C29 2.24302 27.2054 0.000400898 25 0Z"
          fill="#225E77"
        />
        <path
          d="M4.50018 4C2.0188 4 0 6.24302 0 9C0 11.757 2.0188 14 4.50018 14C6.98156 14 9 11.757 9 9C9 6.24302 6.98156 4 4.50018 4Z"
          fill="#225E77"
        />
        <path
          d="M44.4998 4C42.0184 4 40 6.24311 40 9.0002C40 11.7569 42.0184 14 44.4998 14C46.9812 14 49 11.7569 49 9.0002C49 6.24311 46.9812 4 44.4998 4Z"
          fill="#225E77"
        />
        <path
          d="M40.5203 33H8.47967C7.6624 33 7 32.3255 7 31.4933V27H42V31.4933C42 32.3255 41.3376 33 40.5203 33Z"
          fill="#225E77"
        />
        <path
          d="M25 33H40.5626C41.3565 33 42 32.3255 42 31.4933V27H25V33Z"
          fill="#225E77"
        />
      </svg>
    )}
    {...props}
  />
);

const GoldenCrownIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 22 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.087 12.5716H3.91313C3.69658 12.5716 3.49427 12.4593 3.37235 12.2714C1.50226 9.39165 1.35879 3.85203 1.34794 3.0297C1.34726 2.99747 1.34692 2.96488 1.34692 2.93247C1.34692 2.55336 1.63927 2.24583 2.0003 2.24512H2.00166C2.36201 2.24512 2.65487 2.55122 2.65622 2.9298C2.65622 2.93443 2.65639 2.97503 2.65792 3.04697C2.71558 5.00273 4.24872 6.57492 6.12491 6.57492C8.03757 6.57492 9.5936 4.94094 9.5936 2.93247C9.5936 2.55282 9.8868 2.24512 10.2482 2.24512H11.7518C12.1133 2.24512 12.4064 2.55282 12.4064 2.93247C12.4064 4.94094 13.9626 6.57492 15.8752 6.57492C17.7531 6.57492 19.2873 4.99988 19.3424 3.04163C19.3436 2.97289 19.3439 2.93443 19.3439 2.92998C19.3453 2.55122 19.638 2.24512 19.9985 2.24512H19.9997C20.3607 2.24583 20.653 2.55336 20.653 2.93247C20.653 2.96506 20.6527 2.99747 20.6522 3.02988C20.6412 3.85203 20.4977 9.39183 18.6278 12.2716C18.5059 12.4593 18.3034 12.5716 18.087 12.5716Z"
          fill="#FFCF5F"
        />
        <path
          d="M11 0C9.88592 0 8.97955 1.00711 8.97955 2.24499C8.97955 3.48286 9.88592 4.4898 11 4.4898C12.114 4.4898 13.0204 3.48286 13.0204 2.24499C13.0204 1.00711 12.114 0 11 0Z"
          fill="#FFA73B"
        />
        <path
          d="M11.2245 0V4.4898C12.2148 4.48962 13.0204 3.48272 13.0204 2.2449C13.0204 1.00707 12.2147 0.000179995 11.2245 0Z"
          fill="#FFA73B"
        />
        <path
          d="M2.02049 1.7959C0.906401 1.7959 0 2.80297 0 4.0408C0 5.27862 0.906401 6.28569 2.02049 6.28569C3.13458 6.28569 4.04082 5.27862 4.04082 4.0408C4.04082 2.80297 3.13458 1.7959 2.02049 1.7959Z"
          fill="#FFA73B"
        />
        <path
          d="M19.9795 1.7959C18.8654 1.7959 17.9592 2.80301 17.9592 4.04089C17.9592 5.27858 18.8654 6.28569 19.9795 6.28569C21.0936 6.28569 22 5.27858 22 4.04089C22 2.80301 21.0936 1.7959 19.9795 1.7959Z"
          fill="#FFA73B"
        />
        <path
          d="M18.1928 14.8159H3.80716C3.44023 14.8159 3.14282 14.5131 3.14282 14.1395V12.1221H18.8571V14.1395C18.8571 14.5131 18.5597 14.8159 18.1928 14.8159Z"
          fill="#FFA73B"
        />
        <path
          d="M11.2245 14.8159H18.2118C18.5682 14.8159 18.8571 14.5131 18.8571 14.1395V12.1221H11.2245V14.8159Z"
          fill="#FFA73B"
        />
      </svg>
    )}
    {...props}
  />
);

const PrescriptionIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 21 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5552 15.1167V4.7264C17.5552 4.54392 17.48 4.37138 17.3574 4.24883L13.3064 0.19788C13.1829 0.0743904 13.0114 0 12.8288 0H0.675219C0.302323 0 0 0.302323 0 0.675219V20.9312C0 21.3041 0.302323 21.6065 0.675219 21.6065H8.46577C9.51829 23.4212 12.1367 23.4012 13.1613 21.5707C14.7141 23.3987 17.4642 23.4656 19.1145 21.8154C21.2398 19.69 20.3774 16.0725 17.5552 15.1167ZM13.9231 20.3226C12.8674 18.5315 14.1544 16.2511 16.2499 16.2511C16.725 16.2511 17.2001 16.3754 17.6218 16.6239L13.9231 20.3226ZM12.1536 16.88H9.45284V14.8544C9.45284 14.1098 10.0586 13.504 10.8032 13.504C11.5479 13.504 12.1536 14.1098 12.1536 14.8544V16.88ZM13.5041 2.30529L15.25 4.05122H13.5041V2.30529ZM1.35044 20.256V1.35039H12.1537V4.7264C12.1537 5.09929 12.456 5.40162 12.8289 5.40162H16.2049V14.9024C15.2336 14.9131 14.2658 15.27 13.5041 15.9731V14.8545C13.5041 13.3653 12.2925 12.1537 10.8033 12.1537C9.31412 12.1537 8.10254 13.3653 8.10254 14.8545V20.2561H1.35044V20.256ZM10.8032 21.6064C10.0586 21.6064 9.45284 21.0007 9.45284 20.256V18.2304H12.1536V20.256C12.1536 21.0007 11.5479 21.6064 10.8032 21.6064ZM18.1596 20.8604C17.2714 21.7486 15.9133 21.8876 14.8779 21.2774L18.5766 17.5787C19.1868 18.614 19.0479 19.9722 18.1596 20.8604Z"
          fill="white"
        />
        <path
          d="M3.37602 6.75205H10.128C10.5009 6.75205 10.8033 6.44973 10.8033 6.07683C10.8033 5.70393 10.5009 5.40161 10.128 5.40161H3.37602C3.00313 5.40161 2.70081 5.70393 2.70081 6.07683C2.70085 6.44977 3.00313 6.75205 3.37602 6.75205Z"
          fill="white"
        />
        <path
          d="M3.37602 9.45273H10.128C10.5009 9.45273 10.8033 9.15041 10.8033 8.77751C10.8033 8.40462 10.5009 8.10229 10.128 8.10229H3.37602C3.00313 8.10229 2.70081 8.40462 2.70081 8.77751C2.70081 9.15041 3.00313 9.45273 3.37602 9.45273Z"
          fill="white"
        />
        <path
          d="M7.44971 10.8257H3.39849C3.02559 10.8257 2.72327 11.128 2.72327 11.5009C2.72327 11.8738 3.02559 12.1761 3.39849 12.1761H7.44971C7.8226 12.1761 8.12493 11.8738 8.12493 11.5009C8.12493 11.128 7.8226 10.8257 7.44971 10.8257Z"
          fill="white"
        />
        <path
          d="M6.07685 16.2048H3.37602C3.00313 16.2048 2.70081 16.5072 2.70081 16.8801C2.70081 17.2529 3.00313 17.5553 3.37602 17.5553H6.07681C6.44971 17.5553 6.75203 17.2529 6.75203 16.8801C6.75203 16.5072 6.44975 16.2048 6.07685 16.2048Z"
          fill="white"
        />
      </svg>
    )}
    {...props}
  />
);

const PrescriptionIconDark = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.2123 10.5159V3.28793C12.2123 3.16099 12.16 3.04096 12.0747 2.95571L9.25663 0.137656C9.17072 0.0517499 9.05141 0 8.92441 0H0.469718C0.210312 0 0 0.210312 0 0.469717V14.5609C0 14.8203 0.210312 15.0306 0.469718 15.0306H5.88923C6.62142 16.293 8.44291 16.2791 9.15569 15.0057C10.2359 16.2774 12.149 16.3239 13.297 15.1759C14.7755 13.6974 14.1756 11.1808 12.2123 10.5159ZM9.68563 14.1374C8.95126 12.8915 9.84657 11.3051 11.3043 11.3051C11.6348 11.3051 11.9653 11.3916 12.2586 11.5644L9.68563 14.1374ZM8.4547 11.7426H6.57589V10.3335C6.57589 9.8155 6.99729 9.3941 7.51529 9.3941C8.03329 9.3941 8.4547 9.8155 8.4547 10.3335V11.7426ZM9.39413 1.60368L10.6087 2.81824H9.39413V1.60368ZM0.939435 14.0911V0.939404H8.45473V3.28793C8.45473 3.54733 8.66504 3.75765 8.92444 3.75765H11.273V10.3669C10.5973 10.3743 9.92407 10.6226 9.39416 11.1117V10.3335C9.39416 9.29757 8.55132 8.45473 7.51535 8.45473C6.47939 8.45473 5.63655 9.29757 5.63655 10.3335V14.0912H0.939435V14.0911ZM7.51529 15.0306C6.99729 15.0306 6.57589 14.6091 6.57589 14.0911V12.682H8.4547V14.0911C8.4547 14.6091 8.03329 15.0306 7.51529 15.0306ZM12.6328 14.5116C12.0149 15.1295 11.0701 15.2262 10.3499 14.8017L12.9229 12.2287C13.3474 12.9489 13.2507 13.8937 12.6328 14.5116Z"
          fill="#505050"
        />
        <path
          d="M2.34881 4.69774H7.04586C7.30526 4.69774 7.51557 4.48742 7.51557 4.22802C7.51557 3.96861 7.30526 3.7583 7.04586 3.7583H2.34881C2.0894 3.7583 1.87909 3.96861 1.87909 4.22802C1.87912 4.48745 2.0894 4.69774 2.34881 4.69774Z"
          fill="#505050"
        />
        <path
          d="M2.34881 6.57518H7.04586C7.30526 6.57518 7.51557 6.36487 7.51557 6.10546C7.51557 5.84605 7.30526 5.63574 7.04586 5.63574H2.34881C2.0894 5.63574 1.87909 5.84605 1.87909 6.10546C1.87909 6.36487 2.0894 6.57518 2.34881 6.57518Z"
          fill="#505050"
        />
        <path
          d="M5.18197 7.52979H2.36373C2.10432 7.52979 1.89401 7.7401 1.89401 7.9995C1.89401 8.25891 2.10432 8.46922 2.36373 8.46922H5.18197C5.44138 8.46922 5.65169 8.25891 5.65169 7.9995C5.65169 7.74007 5.44138 7.52979 5.18197 7.52979Z"
          fill="#505050"
        />
        <path
          d="M4.22765 11.272H2.34881C2.0894 11.272 1.87909 11.4823 1.87909 11.7417C1.87909 12.0011 2.0894 12.2114 2.34881 12.2114H4.22761C4.48702 12.2114 4.69733 12.0011 4.69733 11.7417C4.69733 11.4823 4.48705 11.272 4.22765 11.272Z"
          fill="#505050"
        />
      </svg>
    )}
    {...props}
  />
);

const EmptyStarIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 11 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_ii)">
          <path
            d="M10.1606 3.52128L7.01293 3.06505L5.60583 0.220085C5.5674 0.142191 5.50417 0.0791345 5.42607 0.0408059C5.23019 -0.0556336 4.99216 0.0247327 4.89422 0.220085L3.48712 3.06505L0.339421 3.52128C0.252639 3.53365 0.173296 3.57445 0.112549 3.63627C0.0391089 3.71155 -0.00135988 3.81283 3.48936e-05 3.91785C0.00142967 4.02287 0.0445739 4.12305 0.119987 4.19636L2.39739 6.41076L1.85934 9.53763C1.84672 9.61037 1.85479 9.68517 1.88264 9.75357C1.91048 9.82197 1.95698 9.88121 2.01687 9.92459C2.07676 9.96797 2.14764 9.99375 2.22147 9.999C2.2953 10.0042 2.36913 9.98876 2.43458 9.9543L5.25003 8.47803L8.06547 9.9543C8.14233 9.9951 8.2316 10.0087 8.31714 9.99386C8.53285 9.95677 8.6779 9.75276 8.64071 9.53763L8.10266 6.41076L10.3801 4.19636C10.442 4.13578 10.483 4.05665 10.4954 3.9701C10.5288 3.75373 10.3776 3.55343 10.1606 3.52128Z"
            fill="white"
          />
        </g>
        <path
          d="M6.90089 3.12047L6.93001 3.17934L6.995 3.18876L10.1423 3.64493C10.1424 3.64494 10.1424 3.64495 10.1425 3.64496C10.2925 3.66727 10.3944 3.80496 10.3718 3.95099L10.3716 3.95238C10.3632 4.0111 10.3354 4.06519 10.2927 4.10693C10.2927 4.10694 10.2927 4.10696 10.2927 4.10697L8.01552 6.32114L7.96831 6.36705L7.97947 6.43196L8.51752 9.55883L8.51754 9.55892C8.54286 9.70539 8.44419 9.84518 8.29596 9.87067L8.29578 9.8707C8.23697 9.8809 8.17591 9.8714 8.12408 9.84389L8.12352 9.84359L5.30807 8.36733L5.25003 8.33689L5.19198 8.36733L2.37653 9.84359L2.37634 9.84369C2.33152 9.8673 2.28093 9.87791 2.23033 9.87431C2.17974 9.87072 2.13119 9.85305 2.0902 9.82336L2.01687 9.92459L2.0902 9.82336C2.04921 9.79367 2.01743 9.75316 1.99841 9.70644C1.97939 9.65973 1.97389 9.60865 1.9825 9.55899L1.98253 9.55883L2.52058 6.43196L2.53174 6.36705L2.48453 6.32114L0.207127 4.10674L0.207119 4.10673C0.155465 4.05652 0.125977 3.98798 0.125024 3.91619C0.124072 3.84449 0.151665 3.77527 0.201853 3.72373C0.243695 3.68122 0.297985 3.65345 0.357052 3.64504L0.357351 3.64499L3.50505 3.18876L3.57004 3.17934L3.59916 3.12047L5.00596 0.276107C5.00601 0.276006 5.00606 0.275905 5.00611 0.275804C5.07347 0.141863 5.23691 0.0870017 5.37085 0.152951L5.371 0.153022C5.42438 0.179217 5.46753 0.222287 5.49373 0.275393L5.49379 0.275501L6.90089 3.12047ZM3.48712 3.06505L0.339421 3.52128L3.48712 3.06505ZM2.39739 6.41076L1.85934 9.53763L0.112549 3.63627C0.0391089 3.71155 -0.00135988 3.81283 3.48936e-05 3.91785C0.00142967 4.02287 0.0445739 4.12305 0.119987 4.19636L2.39739 6.41076Z"
          stroke="#838383"
          strokeOpacity="0.75"
          strokeWidth="0.25"
        />
        <defs>
          <filter
            id="filter0_ii"
            x="-1"
            y="-1"
            width="12.5"
            height="12"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1" dy="1" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-1" dy="-1" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.991667 0 0 0 0 0.987535 0 0 0 0 0.987535 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_innerShadow"
              result="effect2_innerShadow"
            />
          </filter>
        </defs>
      </svg>
    )}
    {...props}
  />
);

const CashIcon = (props: any) => (
  <Icon
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3259_539)">
          <path
            d="M19.7915 14.5837V6.25033C19.7915 5.10449 18.854 4.16699 17.7082 4.16699H3.12484C1.979 4.16699 1.0415 5.10449 1.0415 6.25033V14.5837C1.0415 15.7295 1.979 16.667 3.12484 16.667H17.7082C18.854 16.667 19.7915 15.7295 19.7915 14.5837ZM17.7082 14.5837H3.12484V6.25033H17.7082V14.5837ZM10.4165 7.29199C8.68734 7.29199 7.2915 8.68782 7.2915 10.417C7.2915 12.1462 8.68734 13.542 10.4165 13.542C12.1457 13.542 13.5415 12.1462 13.5415 10.417C13.5415 8.68782 12.1457 7.29199 10.4165 7.29199ZM23.9582 7.29199V18.7503C23.9582 19.8962 23.0207 20.8337 21.8748 20.8337H4.1665C4.1665 19.792 4.1665 19.8962 4.1665 18.7503H21.8748V7.29199C23.0207 7.29199 22.9165 7.29199 23.9582 7.29199Z"
            fill="#505050"
          />
        </g>
        <defs>
          <clipPath id="clip0_3259_539">
            <rect width={25} height={25} fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}
    {...props}
  />
);

export {
  EmptyStarIcon,
  ReorderIcon,
  ChatIcon,
  ActiveOrdersIcon,
  DownloadBillIcon,
  LoyaltyIcon,
  LoyaltyProgramIcon,
  PrescriptionIcon,
  PrescriptionIconDark,
  CrownIcon,
  GoldenCrownIcon,
  MicIcon,
  CashIcon,
};
